import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

const [
  LIST_CHANCE_TECH_FILES,
  LIST_CHANCE_TECH_FILES_SUCCESS,
  LIST_CHANCE_TECH_FILES_FAILURE,
] = createRequestActionTypes('chance/LIST_CHANCE_TECH_FILES');

export const listChanceTechFiles = createAction(
  LIST_CHANCE_TECH_FILES,
  (fileTyp, fileAttrVal1) => ({ fileTyp, fileAttrVal1 }),
);
const listChanceTechFilesSaga = createRequestSaga(
  LIST_CHANCE_TECH_FILES,
  chanceApi.getChanceFiles,
);

const UNLOAD_TECH_FILES = 'chance/UNLOAD_TECH_FILES';
export const unloadTechFiles = createAction(UNLOAD_TECH_FILES);

export function* chanceTechFilesSaga() {
  yield takeLatest(LIST_CHANCE_TECH_FILES, listChanceTechFilesSaga);
}

const initialState = {
  files: null,
  error: null,
};

const chanceTechFiles = handleActions(
  {
    [LIST_CHANCE_TECH_FILES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      files: data.list.map((file) => ({
        id: file.fileUuid,
        fileUrl: file.fileUrl,
        fileTyp: file.fileTyp,
        fileAttrVal1: file.fileAttrVal1, //prjUuid
        fileAttrVal2: file.fileAttrVal2,
        fileAttrVal3: file.fileAttrVal3,
        fileNm: file.fileNm,
        fileDesc: file.fileDesc,
        crtNm: file.crtNm,
        crtDt: file.crtDt,
        cngNm: file.cngNm,
        cngDt: file.cngDt,
      })),
      error: null,
    }),
    [LIST_CHANCE_TECH_FILES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_TECH_FILES]: () => initialState,
  },
  initialState,
);

export default chanceTechFiles;
